<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18AWC3m/tc-custom/9780738760797.jpg?1741984803119" alt="This image is the cover for the book Horrors of Fox Hollow Farm"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Horrors of Fox Hollow Farm
      </h1>
      <p class="bookDescription body article font2">
        <p>Fox Hollow Farm, the infamous Indiana property where Herb Baumeister allegedly murdered at least eleven men, has a grim past and an unsettling present. This riveting book pieces together the story of the tragic case and explores the paranormal encounters that continue to this day, delving into the psyche of a suspected murderer and the terrifying supernatural activity that lingers in the aftermath of such unspeakable evil.</p><p><i>The Horrors of Fox Hollow Farm</i> provides detailed insights from the original criminal investigation as well as the perspectives of the man who survived Herb's attempt on his life. This chilling book also features actual supernatural evidence—from EVPs and psychic confirmations to first-hand accounts of the disembodied hands and voices that regularly manifest on the estate.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Estep, Robert Graves
      </h2>
      
      <p class="authorDescription body article"><B>Richard Estep</B> has been a paranormal investigator for thirty years, researching claims of ghosts and hauntings on both sides of the Atlantic. He is the author of more than thirty books, in genres ranging from paranormal non-fiction and true crime to history and fiction. He is a cast member of the TV shows <I>Haunted Hospitals</I>, <I>Paranormal Revenge</I>, and <I>Paranormal 911</I>, and has made guests appearances on <I>A Haunting,</I><I>Destination Fear</I>, and <I>Haunted Case Files</I>.  Richard writes a regular column for <I>Haunted Magazin</I>e and frequently presents at conferences and public events across the United States. A paramedic by profession, Richard lives in Colorado with his family. Visit him at RichardEstep.net.<P><B>Robert Graves</B> (Indianapolis, IN) is the owner of Fox Hollow Farm. Since learning of the farm’s past, Robert has devoted himself to understanding the tragic events that took place there.</P>~</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02f2afcd